export default [{
		id: 1,
		name: '资源名称1',
		fileUrl: '/file/1.pdf',
		fileType: 'pdf'
	}, {
		id: 2,
		name: '资源名称2',
		fileUrl: '/file/sz.png',
		fileType: 'img'
	}, {
		id: 3,
		name: '资源名称3',
		fileUrl: '/file/jidi.mp4',
		fileType: 'video'
	}, {
		id: 4,
		name: '资源名称4',
		fileUrl: '/file/sz.png',
		fileType: 'img'
	}, {
		id: 5,
		name: '资源名称5',
		fileUrl: '/file/jidi.mp4',
		fileType: 'video'
	},
	{
		id: 6,
		name: '资源名称6',
		fileUrl: '/file/1.pdf',
		fileType: 'pdf'
	}
]